/*
 * Winners Page
 * @route: "/winners"
*/


import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import {Image, Col} from 'react-bootstrap';
import {connect} from 'react-redux';

//APPs
import Utils from '../../utils/utils';
import WinnersApi from '../../api/winner-api';

//COMPONENTS
import TableWinners from '../shared/tableWinners.component.jsx';



class Winners extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		WinnersApi.getWinners();
	}

	render() {
		return (
			<div>
			<div className="bg-red shadow hideOverflow">
				<div className="container-secondary panel-ganhadores">
					<Col sm={12}>
						<Image src={Utils.getImgPath() + "panel-ganhadores-img.png"} alt="" className="ganhadores-img hidden-sm hidden-xs"/>
						<Image src={Utils.getImgPath() + "baloon-ganhadores.png"} alt="" className="baloon-ganhadores hidden-sm hidden-xs"/>
						<h1 className="text-bold text-center text-white"><FormattedHTMLMessage id="panelWinners.title"/></h1>										
						<h2 className="text-light text-center text-white"><FormattedHTMLMessage id="panelWinners.subTitle"/></h2>
					</Col>
				</div>
			</div>
			<div className="container-flex">						
				<Col md={12} className="panel-ganhadores">
					<TableWinners period="MONTHLY" winner={this.props.winner["MONTHLY"]} />
					<TableWinners period="WEEKLY" winner={this.props.winner["WEEKLY"]} />
					<TableWinners period="TRIMESTRIAL" winner={this.props.winner["TRIMESTRIAL"]} />
				</Col>						
			</div>
			</div>
		)
	}
}

const mapStateToProps = function (store) {
	return {
		winner: store.winnerState
	};
};

export default connect(mapStateToProps)(Winners);


// WEBPACK FOOTER //
// ./src/components/pages/winners.component.jsx